import { render, staticRenderFns } from "./readResults.vue?vue&type=template&id=fcf64750&scoped=true"
import script from "./readResults.vue?vue&type=script&lang=js"
export * from "./readResults.vue?vue&type=script&lang=js"
import style0 from "./readResults.vue?vue&type=style&index=0&id=fcf64750&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf64750",
  null
  
)

export default component.exports